import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

export default CreateReactClass({
    displayName: 'set-goal-button',

    propTypes: {
        buttonId: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        disabled: PropTypes.bool.isRequired,
        testScoresMissing: PropTypes.bool.isRequired,
    },

    render() {
        const button = (
            <button
                id={this.props.buttonId}
                className="set-goal-button"
                onClick={this.props.onClick}
                disabled={this.props.disabled}
            >
                Set Goal
            </button>
        );

        const tooltipText = this.props.testScoresMissing
            ? 'No previous test scores to calculate growth goal.'
            : 'The values entered are not valid.';
        const containerClass = 'set-goal-container' + (this.props.disabled ? ' show-tooltip' : '');
        const tooltip = <div className="tooltip">{tooltipText}</div>;
        const arrow = <div className="tooltip arrow" />;

        return (
            <div className={containerClass}>
                {tooltip}
                {arrow}
                {button}
            </div>
        );
    },
});
